import React, { useState } from "react";
import ThemeDrawer from "./ThemeDrawer";
import styles from "./video-highlight.module.css";
import { FaMagic } from "react-icons/fa";
const Theme = () => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const toggleDrawer = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div className={`${styles.themeWrapper}`}>
      <div>
        <button
          className="small-btn mt-17"
          onClick={toggleDrawer}
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handlePopoverClose}
        >
          <FaMagic
            style={{
              marginRight: "12px",
              fontSize: "15",
            }}
          />
          Add Theme
        </button>
        <ThemeDrawer
          isOpen={isDrawerOpen}
          onClose={toggleDrawer}
          setDrawerOpen={setDrawerOpen}
        />
      </div>
    </div>
  );
};

export default Theme;
